export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">联系我们</h2>
            <p className="text-sm text-gray-500 mt-2">有任何问题或建议，欢迎随时联系我们</p>
          </div>

          <div className="max-w-lg mx-auto">
            <div className="bg-gray-50 rounded-2xl p-8 md:p-10 border border-gray-100 text-center">
              <div className="w-16 h-16 rounded-2xl bg-brand-50 flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-brand-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">投稿与合作咨询</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-6">
                如果您有优质影视资源推荐、内容合作意向或任何问题反馈，
                欢迎通过以下方式与我们取得联系，我们会在24小时内回复。
              </p>
              <div className="space-y-4">
                <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                  <i className="ri-mail-line text-brand-600 w-4 h-4 flex items-center justify-center"></i>
                  <span>contact@90ys.com</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                  <i className="ri-wechat-line text-green-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>微信公众号：90影视</span>
                </div>
                <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                  <i className="ri-weibo-line text-red-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>微博：@90影视官方</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}